import React from "react";
import Divider from "./Divider";

export default function Introduction({ title, text, divider }) {
  return (
    <>
      <div className="w-[90%] my-[24px] md:my-0 md:w-[61%] mx-auto text-center">
        <h2 className="text-[24px] leading-[32px] md:text-[34px] font-bold md:leading-[41px] text-[#151515] mt-[40px]">
          {title}
        </h2>

        <p className="pt-[1%] leading-[20px] text-[#373737] font-open text-[16px]">
          {text}
        </p>
      </div>

      {divider ? <Divider /> : null}
    </>
  );
}
